var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46801 0.0231519C5.60293 0.179908 3.82046 0.992141 2.46725 2.30195C1.25032 3.47991 0.451095 4.96173 0.111274 6.6702C0.0167514 7.1454 -0.00163482 7.39608 0.00010913 8.18624C0.00190291 9.01437 0.0187445 9.21208 0.134593 9.76447C0.659074 12.2655 2.24831 14.3427 4.48715 15.4532C5.7127 16.0611 6.75005 16.3018 8.14068 16.3009C9.07748 16.3004 9.59404 16.2319 10.396 16.0022C12.5975 15.3714 14.4518 13.811 15.4706 11.7322C15.7856 11.0892 16.0397 10.3161 15.9948 10.1372C15.9224 9.84848 15.634 9.70079 15.3188 9.79103C15.2212 9.81893 14.9464 9.89985 14.7081 9.9708C13.5718 10.3091 12.2348 10.2318 11.0954 9.76193C9.48626 9.09838 8.28388 7.71916 7.81047 5.99385C7.68491 5.53623 7.67375 5.42238 7.67375 4.59868C7.67375 3.77574 7.68501 3.66074 7.81017 3.20352C7.97914 2.58656 8.34143 1.8249 8.69481 1.34392C8.84225 1.14327 9.01325 0.910126 9.07494 0.825818C9.30579 0.510163 9.15486 0.128437 8.76352 0.0381001C8.57462 -0.00554852 7.90186 -0.0132717 7.46801 0.0231519Z",
    fill: "#6DDAF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.f88226579bb869e04ced5b2dfe7951ff.svg";
export { ForwardRef as ReactComponent };